type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16'
};

/**
 * Spinner Component
 * Loading spinner with various sizes
 */
export default function Spinner({
  size = 'md',
  className = ''
}: SpinnerProps): JSX.Element {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg
        className={`animate-spin text-slate-800 ${sizeClasses[size]}`}
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-20"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );
}

interface LoadingOverlayProps {
  message?: string;
}

/**
 * Loading Overlay Component
 * Full screen or container loading overlay
 */
export function LoadingOverlay({
  message = 'Loading...'
}: LoadingOverlayProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center p-12">
      <Spinner size="lg" />
      <p className="mt-4 text-slate-600">{message}</p>
    </div>
  );
}
